import axiosInstance from "../axios_instance";

export async function transferClient(body) {
  try {
    const url = `transfers/transfer-client`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function transferOrder(body) {
  try {
    const url = `transfers/transfer-order`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function transferEmployee(body) {
  try {
    const url = `transfers/transfer-employee`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}

export async function getRemainingHierarchyCount(body) {
  try {
    const url = `roles/get_remaining_hierarchy_count`
    return await axiosInstance.post(url, body);
  } catch (error) {
    return error;
  }
}
